import * as internal from "./internal/ref.js";
/**
 * @since 2.0.0
 * @category symbols
 */
export const RefTypeId = internal.RefTypeId;
/**
 * @since 2.0.0
 * @category constructors
 */
export const make = internal.make;
/**
 * @since 2.0.0
 * @category getters
 */
export const get = internal.get;
/**
 * @since 2.0.0
 * @category utils
 */
export const getAndSet = internal.getAndSet;
/**
 * @since 2.0.0
 * @category utils
 */
export const getAndUpdate = internal.getAndUpdate;
/**
 * @since 2.0.0
 * @category utils
 */
export const getAndUpdateSome = internal.getAndUpdateSome;
/**
 * @since 2.0.0
 * @category utils
 */
export const modify = internal.modify;
/**
 * @since 2.0.0
 * @category utils
 */
export const modifySome = internal.modifySome;
/**
 * @since 2.0.0
 * @category utils
 */
export const set = internal.set;
/**
 * @since 2.0.0
 * @category utils
 */
export const setAndGet = internal.setAndGet;
/**
 * @since 2.0.0
 * @category utils
 */
export const update = internal.update;
/**
 * @since 2.0.0
 * @category utils
 */
export const updateAndGet = internal.updateAndGet;
/**
 * @since 2.0.0
 * @category utils
 */
export const updateSome = internal.updateSome;
/**
 * @since 2.0.0
 * @category utils
 */
export const updateSomeAndGet = internal.updateSomeAndGet;
/**
 * @since 2.0.0
 * @category unsafe
 */
export const unsafeMake = internal.unsafeMake;
//# sourceMappingURL=Ref.js.map